import { INVOICE_NINJA } from 'constants/inventory';

const integration = {
  status: 'active',
  type: INVOICE_NINJA,
  createdat: '2025-07-31T11:07:54.000Z',
  lastupdated: '2025-07-31T11:48:37.000Z',
  id: '813a2f2a-efc1-4ee8-892b-53d53411b05a',
  company_id: '5873e31d-4d51-4eb7-ad33-06665d9b8e42',
  details: {
    url: 'https://invoicing.example.com/api/v1',
    credentials: {
      apikey: 'fake-invoice-ninja-api-key',
    },
  },
};

export default integration;
